type TaxonomyNode = {
  id: string;
  name: string;
  children?: readonly TaxonomyNode[];
};

export type TaxonomyChainStep = { id: string; name: string };

export type TaxonomyIcicleIndex = {
  levelIds: readonly string[];
  chainsByDepth: readonly ReadonlyMap<string, readonly TaxonomyChainStep[]>[];
};

export function indexTaxonomy(
  nodes: readonly TaxonomyNode[],
  levelIds: readonly string[]
): TaxonomyIcicleIndex | null {
  if (levelIds.length === 0) return null;
  const chainsByDepth = levelIds.map(
    () => new Map<string, readonly TaxonomyChainStep[]>()
  );
  const visit = (node: TaxonomyNode, chain: readonly TaxonomyChainStep[]) => {
    const byId = chainsByDepth[chain.length];
    if (byId === undefined) return;
    const next = [...chain, { id: String(node.id), name: node.name }];
    byId.set(String(node.id), next);
    for (const child of node.children ?? []) visit(child, next);
  };
  for (const root of nodes) visit(root, []);
  return { levelIds, chainsByDepth };
}
